import React from "react";
import { DynamicFieldProps } from "../../../model/dynamic-forms";
import DynamicFormGenerator from "../DynamicFormGenerator";

const DynamicField: React.FC<DynamicFieldProps> = (props) => {
	return <>{DynamicFormGenerator.generateDynamicField(props)}</>;
};

export default DynamicField;

